<template>
  <v-container fluid>
    <v-row>
      <v-col xs12 md3 offset-md1 class="hidden-sm-and-down">
        <v-card>
        <!--
          <v-toolbar class="teal white--text">
            <v-toolbar-side-icon></v-toolbar-side-icon>
            <v-toolbar-title>Topics</v-toolbar-title>
            <v-icon>more_vert</v-icon>
          </v-toolbar>
        -->
          <v-list dense>
            <v-list-group v-for="item in options" v-model="item.active" v-bind:key="item.title">
              <v-list-tile slot="item">
                <v-list-tile-action>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon>keyboard_arrow_down</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-item v-for="subItem in item.items" v-bind:key="subItem.title">
                <v-list-tile router :href="'/user/' + subItem.value">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon>{{ subItem.action }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
      </v-col>

      <v-col xs12 sm12 md7>
        <v-content>
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </v-content>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapMutations } from 'vuex'

  export default {

    name: 'User',

    data () {
      return {
        page: 'Profile',
        options: [
          {
            title: '基本設定',
            active: true,
            items: [
              {
                title: '個人資料',
                value: 'profile'
              }
            ]
          }
        ],
        rules: []
      }
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '控制面板',
        link: '/user'
      })
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// User.vue?5f4fe4be